import { createActionCreator } from '@pressreader/appstore';
import { AnyFeedCursor } from '@pressreader/feed-types';
import { IPoint } from '@pressreader/geometry';
import { IssueViewNavigationConfig } from '@pressreader/views-navigation';

import { MODULE_NAME } from '../../constants';
import { ArticleActionPayload } from '../../types/article.action.payload';

const prefix = `${MODULE_NAME}/menu/`;

export const openArticleMenuAction = createActionCreator<{
    articleId: string;
    language?: string;

    /**
     * The article id that should be used for reading/writing comments.
     */
    primaryArticleId: string | undefined;

    /** Means that article menu was requested outside Article View. */
    proxied?: boolean;

    center: IPoint;

    issueViewNavigation?: IssueViewNavigationConfig;
    textViewContextKey?: string;
    pageViewContextKey?: string;
    cursor: AnyFeedCursor | null;
}>(`${prefix}open-article-menu`);

export const articleMenuOpened = createActionCreator<ArticleActionPayload>(`${prefix}article-menu-opened`);
export const articleMenuClosed = createActionCreator<ArticleActionPayload>(`${prefix}article-menu-closed`);
